"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _Flex = _interopRequireDefault(require("../../Flex"));

var _Icon = _interopRequireDefault(require("../../Icon"));

var _useTheme2 = _interopRequireDefault(require("../../styles/useTheme"));

var _Decoration = _interopRequireDefault(require("./Decoration"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var useStyles = function useStyles() {
  var _useTheme = (0, _useTheme2.default)(),
      spacing = _useTheme.spacing;

  return {
    root: {
      position: 'relative'
    },
    first: {
      position: 'absolute',
      top: spacing(-2.5),
      left: 0,
      transform: "translateX(-".concat(spacing(2.5), ")")
    },
    second: {
      position: 'absolute',
      bottom: spacing(-2.5),
      right: 0,
      transform: "translateX(".concat(spacing(2.5), ") rotateZ(90deg) rotateY(180deg)")
    }
  };
};

__signature__(useStyles, "useTheme{{ spacing }}", function () {
  return [_useTheme2.default];
});

var CheeryContainer = function CheeryContainer(props) {
  var _props$color = props.color,
      color = _props$color === void 0 ? 'primary' : _props$color,
      children = props.children,
      other = (0, _objectWithoutProperties2.default)(props, ["color", "children"]);
  var classes = useStyles();
  return (0, _core.jsx)(_Flex.default, (0, _extends2.default)({
    flexDirection: "column",
    alignItems: "stretch",
    css: classes.root
  }, other), (0, _core.jsx)(_Icon.default, {
    css: classes.first,
    as: _Decoration.default,
    color: color,
    size: 3.5
  }), children, (0, _core.jsx)(_Icon.default, {
    css: classes.second,
    as: _Decoration.default,
    color: color,
    size: 3.5
  }));
};

__signature__(CheeryContainer, "useStyles{classes}", function () {
  return [useStyles];
});

var _default = CheeryContainer;
var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useStyles, "useStyles", "/builds/bA1zbJom/0/gojob/ui-bits/src/Cta/CheeryContainer/index.tsx");
  reactHotLoader.register(CheeryContainer, "CheeryContainer", "/builds/bA1zbJom/0/gojob/ui-bits/src/Cta/CheeryContainer/index.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Cta/CheeryContainer/index.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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